import React from 'react';

import StartScreenPopup from '../../shared/components/start-screen-popup';
import CreateBroadcastForm from './features/start-broadcast/create-broadcast-form';

export const CreateBroadcastPage = () => {
    return (
        <StartScreenPopup blur>
            <CreateBroadcastForm />
        </StartScreenPopup>
    );
};
